import { render, staticRenderFns } from "./LeaveDetailModal.vue?vue&type=template&id=7ec1ad23&scoped=true"
import script from "./LeaveDetailModal.vue?vue&type=script&lang=js"
export * from "./LeaveDetailModal.vue?vue&type=script&lang=js"
import style0 from "./LeaveDetailModal.vue?vue&type=style&index=0&id=7ec1ad23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec1ad23",
  null
  
)

export default component.exports